<div class="dialog-container">
    <h1 class="condensed dialog-title">{{data.title}}</h1>
    <div class="dialog-content">
        <p [innerHTML]="data.text"></p>
    </div>
    <div class="d-flex flex-wrap">
        @if (data.cancel) {
            <button (click)="onNoClick()" mat-button>{{data.cancel}}</button>
        }
        <div class="spacer"></div>
        @if (data.confirm) {
            <button [mat-dialog-close]="true" cdkFocusInitial color="primary" mat-raised-button>{{data.confirm}}</button>
        }
    </div>
</div>
